<template>
  <div class="root row hcenter">
    <div class="card m-auto text-white">
      <div class="card-content">
        <!-- TODO: Validate input field accordingly (vee-validate) -->
        <template v-if="apiStatus === 3">
          <status-info status="error" :message="passwordMsg" :timeout="10000" />
        </template>
        <template v-else-if="apiStatus === 2">
          <status-info
            status="success"
            :message="passwordMsg"
            :timeout="10000"
          />
        </template>

        <form @submit.prevent="setNewPassword">
          <!-- TODO find a way to use the value prop properly -->

          <input-field
            label="new password"
            focusClass="text-white"
            iconClickable
            id="password"
            :focus="true"
            :type="passwordInputType"
            :icon="passwordToggleIcon"
            :error="errors.password"
            @iconClick="togglePasswordVisibility"
            @keyup="handleKeys"
          />
          <input-field
            label="confirm password"
            focusClass="text-white"
            iconClickable
            id="passwordConfirm"
            :type="passwordInputType"
            :error="errors.passwordConfirm"
            @iconClick="togglePasswordVisibility"
            @keyup="handleKeys"
          />

          <div class="mt-2">
            <button
              type="submit"
              class="block mb-2 waves"
              :class="apiStatus === 1 ? 'pulse' : null"
            >
              Set Password
            </button>
          </div>
        </form>
        <div class="input-field mb-0">
          <router-link :to="{ name: 'Login' }">Back To Login</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import { mapGetters } from "vuex";

import InputField from "@/components/InputField";
import StatusInfo from "@/components/StatusInfo";

export default {
  name: "PasswordReset",
  components: {
    InputField,
    StatusInfo,
  },
  computed: {
    ...mapGetters({
      apiStatus: "Auth/setNewPasswordStatus",
      passwordMsg: "Auth/setNewPasswordMessage",
    }),
  },
  props: {
    passwordResetToken: {
      type: String,
      default: "",
      required: true,
    },
  },
  data() {
    return {
      passwordInputType: "password",
      passwordToggleIcon: "visibility",

      password: "",
      passwordConfirm: "",

      errors: {
        password: "",
        passwordConfirm: "",
      },

      newPassword: "",
      // token: null,
    };
  },
  created() {
    // let resetToken = localStorage.getItem("passwordToken");
    // this.token = resetToken;
  },
  mounted() {
    T.waves();
  },
  methods: {
    togglePasswordVisibility() {
      if (this.passwordInputType === "password") {
        this.passwordToggleIcon = "visibility_off";
        this.passwordInputType = "text";
      } else {
        this.passwordInputType = "password";
        this.passwordToggleIcon = "visibility";
      }
    },
    validate() {
      if (this.password === "") {
        this.errors.password = "Please enter your new password";
        return false;
      } else {
        this.errors.password = "";
      }

      if (this.password !== this.passwordConfirm) {
        this.errors.passwordConfirm = "The two passwords do not match";
        return false;
      } else {
        this.errors.passwordConfirm = "";
      }

      return true;
    },
    handleKeys(e) {
      if (e.key === "Tab" || e.key === "Shift") return;
      const input = e.target;
      const inputName = input.name;
      const inputValue = input.value.trim();

      this[inputName] = inputValue;
      // this.validate(inputName, inputValue);
    },

    setNewPassword(e) {
      const form = e.target;
      const formData = new FormData(form);
      const password = formData.get("password");
      const passwordConfirm = formData.get("passwordConfirm");

      this.password = password;
      this.passwordConfirm = passwordConfirm;
      if (!this.validate()) return;

      let payload = {
        password,
        token: this.passwordResetToken,
      };

      this.$store.dispatch("Auth/setNewPassword", payload).then(() => {
        if (this.apiStatus === 2) {
          console.log(this.setNewPasswordMessage);
          setTimeout(() => this.$router.replace({ name: "Login" }), 2000);
        } else if (this.apiStatus === 3) {
          // TODO: display error message to the user
          console.log("Error:", this.setNewPasswordMessage);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.root .card {
  width: 100%;
  color: white;
  max-width: 330px;
  background-color: #000000da;

  @supports ((backdrop-filter: blur(20px))) {
    backdrop-filter: blur(20px);
    background-color: #000000a9;
    border: 2px solid #ffffff29;
  }
}
</style>
